import styled from 'styled-components';

const StyledSearchResultsItem = styled.div`
  align-items: center;
  position: relative;

  padding: ${props => props.theme.spacing.small};
  border-radius: ${props => props.theme.border_radius.standard};
  background-color: transparent;
  cursor: ${props =>
    props.disabled
      ? 'not-allowed'
      : props.isDraggable
      ? 'auto'
      : 'pointer'};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  transition: background-color ${props => props.theme.transition.timer}
    ${props => props.theme.transition.ease};

  button.hx-more-info-button,
  button.hx-add-to-query-button {
    display: none;
  }

  .fix-padding {
    padding-left: 0;
    padding-right: 0;
  }

  &:hover,
  &:focus,
  &:active {
    button.hx-more-info-button,
    button.hx-add-to-query-button {
      display: ${props => (props.disabled ? 'none' : 'block')};
    }

    background-color: ${props =>
      props.disabled ? 'transparent' : props.theme.colors.light_dark};
  }

  &:focus {
    outline: none;
  }
`;

const StyledCategoriesText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledSavedQueryIconContainer = styled.div`
  width: ${props => props.theme.avatar_size[props.size]};
  height: ${props => props.theme.avatar_size[props.size]};
  border-radius: ${props => props.theme.border_radius.circle};
  border: 1px solid ${props => props.theme.colors.dark_lighter};
  overflow: hidden;
  cursor: default;
  background-color: ${props => props.theme.colors.violet};
`;

const StyledSavedQueryIcon = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export {
  StyledSearchResultsItem,
  StyledCategoriesText,
  StyledSavedQueryIconContainer,
  StyledSavedQueryIcon,
};
